<template>
  <div v-loading="fullscreenLoading">
    <div style="margin-left: 10.5%">
      <div style="padding: 20px 20px 20px 0px">
        <div
          @click="onGoTo('cate')"
          style="
            padding: 10px;
            font-size: 20px;
            color: #1bb24b;
            font-weight: bold;
            display: inline-block;
            cursor: pointer;
          "
        >
          大项分类
        </div>
        <div
          v-if="boolSubCate"
          style="display: inline-block; vertical-align: middle; cursor: pointer"
        >
          <img
            style="width: 20px; height: 20px"
            src="../assets/arrow-right.png"
          />
        </div>
        <div
          v-if="boolSubCate"
          style="
            padding: 10px;
            font-size: 20px;
            color: #1bb24b;
            font-weight: bold;
            display: inline-block;
            cursor: pointer;
          "
        >
          小项分类
        </div>
      </div>
      <div
        v-if="!boolSubCate"
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 200) + 'px' }"
      >
        <div style="padding: 3%">
          <div style>
            <div style="display: inline-block; width: 70%">
              <el-button
                @click="onDialogBoolAddNewOpen()"
                style="color: #1bb24b; border-color: #1bb24b"
                >添加新类目</el-button
              >
            </div>
            <div style="display: inline-block; text-align: right; width: 30%">
              <div
                style="
                  display: inline-block;
                  text-align: right;
                  max-width: 40%;
                  margin-right: 10px;
                "
              ></div>
            </div>
          </div>

          <div style="margin-top: 3%">
            <el-table
              :data="tableDataList"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column
                prop="name"
                label="名称"
                sortable
                width="300"
              ></el-table-column>

              <el-table-column label="分类图片（主页展示 250px X 250px）">
                <template slot-scope="scope">
                  <img
                    style="width: 80px; height: 80px"
                    :src="scope.row.imgUrl"
                  />
                </template>
              </el-table-column>

              <el-table-column label="是否展示在主页" width="200">
                <template slot-scope="scope">
                  <div v-if="scope.row.displayArea == '主页'">是</div>
                  <div v-else>否</div>
                </template>
              </el-table-column>

              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'subCate')"
                    >查看小项</el-button
                  >

                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'up')"
                    >上移</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'down')"
                    >下移</el-button
                  >

                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'edit')"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithData(scope, 'delete')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px"></div>
        </div>
      </div>

      <div
        v-if="boolSubCate"
        class="Rectangle-5"
        v-bind:style="{ height: +(windowHeight - 200) + 'px' }"
      >
        <div style="padding: 3%">
          <div style>
            <div style="display: inline-block; width: 70%">
              <el-button
                @click="onDialogBoolAddNewSubOpen()"
                style="color: #1bb24b; border-color: #1bb24b"
                >添加新分类</el-button
              >
            </div>
            <div style="display: inline-block; text-align: right; width: 30%">
              <div
                style="
                  display: inline-block;
                  text-align: right;
                  max-width: 40%;
                  margin-right: 10px;
                "
              ></div>
            </div>
          </div>

          <div style="margin-top: 3%">
            <el-table
              :data="subCategoriesList"
              :height="windowHeight - 450"
              style="width: 100%"
              stripe
            >
              <el-table-column
                prop="name"
                label="名称"
                sortable
                width="300"
              ></el-table-column>
              <el-table-column label="分类图片（250px X 250px）">
                <template slot-scope="scope">
                  <img
                    style="width: 80px; height: 80px"
                    :src="scope.row.imgUrl"
                  />
                </template>
              </el-table-column>

              <el-table-column label="是否展示在主页" width="200">
                <template slot-scope="scope">
                  <div v-if="scope.row.displayArea == '主页'">是</div>
                  <div v-else>否</div>
                </template>
              </el-table-column>

              <el-table-column fixed="right" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithSubData(scope, 'edit')"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    @click="onDialogWithSubData(scope, 'delete')"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 20px"></div>
        </div>
      </div>

      <!-- **************************** categories operation **************************** -->
      <el-dialog
        title="分类操作"
        :visible.sync="boolAddNew"
        width="70%"
        style="text-align: left"
        :before-close="onDialogBoolAddNewClose"
      >
        <div>
          <div style="display: inline-block; text-align: left; width: 10%">
            添加类型
          </div>
          <el-select
            disabled
            style="display: inline-block; width: 70%"
            v-model="form.type"
          >
            <el-option
              v-for="item in typeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            分类名称
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.name"
          ></el-input>
        </div>

        <div v-if="form.type == '小项'" style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            大项分类
          </div>
          <el-select
            style="display: inline-block; width: 70%"
            v-model="form.belongCategoriesId"
          >
            <el-option
              v-for="item in tableDataList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div v-if="form.type == '大项'" style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            展示情况
          </div>
          <el-select
            style="display: inline-block; width: 70%"
            v-model="form.displayArea"
            placeholder="若需展示在主页则选择‘主页’，不展示在主页则不选或选‘不展示在主页’"
          >
            <el-option
              v-for="item in displayAreaList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div
            style="
              display: inline-block;
              text-align: left;
              width: 10%;
              vertical-align: top;
            "
          >
            分类图片
          </div>

          <div style="display: inline-block; width: 70%">
            <el-upload
              accept=".jpg, .jpeg, .png"
              class="avatar-uploader"
              :show-file-list="false"
              action="https://freshgo.top/api/public/api/v1/uploadFileQiniu"
              :on-success="onImgUpload"
              :on-remove="onImgRemove"
            >
              <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            v-if="boolEdit"
            @click="onEditConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            v-if="boolEdit == false"
            @click="onAddNewConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolAddNewClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="删除分类"
        :visible.sync="boolDelete"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolDeleteClose"
      >
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onDeleteConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolDeleteClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- ************************************************************************************* -->

      <!-- **************************** sub categories operation **************************** -->

      <el-dialog
        title="分类操作"
        :visible.sync="boolAddNewSub"
        width="70%"
        style="text-align: left"
        :before-close="onDialogBoolAddNewSubClose"
      >
        <div>
          <div style="display: inline-block; text-align: left; width: 10%">
            添加类型
          </div>
          <el-select
            disabled
            style="display: inline-block; width: 70%"
            v-model="form.type"
          >
            <el-option
              v-for="item in typeList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            分类名称
          </div>
          <el-input
            style="display: inline-block; width: 70%"
            v-model="form.name"
          ></el-input>
        </div>

        <div v-if="form.type == '小项'" style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            大项分类
          </div>
          <el-select
            style="display: inline-block; width: 70%"
            disabled
            v-model="form.belongCategoriesId"
          >
            <el-option
              v-for="item in tableDataList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div v-if="form.type == '大项'" style="margin-top: 20px">
          <div style="display: inline-block; text-align: left; width: 10%">
            展示情况
          </div>
          <el-select
            style="display: inline-block; width: 70%"
            v-model="form.displayArea"
            placeholder="若需展示在主页，则选择。否则不选"
          >
            <el-option
              v-for="item in displayAreaList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div style="margin-top: 20px">
          <div
            style="
              display: inline-block;
              text-align: left;
              width: 10%;
              vertical-align: top;
            "
          >
            分类图片
          </div>

          <div style="display: inline-block; width: 70%">
            <el-upload
              accept=".jpg, .jpeg, .png"
              class="avatar-uploader"
              :show-file-list="false"
              action="https://freshgo.top/api/public/api/v1/uploadFileQiniu"
              :on-success="onImgUpload"
              :on-remove="onImgRemove"
            >
              <img v-if="form.imgUrl" :src="form.imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>

        <div style="text-align: right; margin-top: 20px">
          <el-button
            v-if="boolEditSub"
            @click="onEditSubConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            v-if="boolEditSub == false"
            @click="onAddNewSubConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolAddNewSubClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="删除分类"
        :visible.sync="boolDeleteSub"
        width="50%"
        style="text-align: left"
        :before-close="onDialogBoolDeleteSubClose"
      >
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="onDeleteSubConfirm()"
            style="
              display: inline-block;
              margin-left: 20px;
              background-color: #1bb24b;
              width: 125px;
            "
            type="success"
            >确认</el-button
          >
          <el-button
            @click="onDialogBoolDeleteSubClose()"
            style="color: #1bb24b; border-color: #1bb24b; width: 125px"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <!-- ************************************************************************************* -->
    </div>
  </div>
</template>

<script>
export default {
  name: "categoriesList",
  data() {
    return {
      fullscreenLoading: false,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,

      searchKeyword: "",

      currentData: {},
      currentPage: 1,
      tableDataList: [],
      tableDataTotal: 0,

      currentSubData: {},

      boolAddNew: false,
      boolEdit: false,
      boolDelete: false,
      boolAddDescription: false,
      boolEditDescription: false,
      boolSubCate: false,
      boolAddNewSub: false,
      boolEditSub: false,
      boolDeleteSub: false,

      form: {
        belongCategoriesId: "",
        name: "",
        type: "",
        displayArea: "",
        imgUrl: "",
      },

      subCategoriesList: [],
      displayAreaList: ["主页", "不展示在主页"],
      typeList: ["大项", "小项"],
    };
  },
  mounted() {},
  created() {
    this.onCheckloginRole();
    this.onFetchProductCategoriesData();
  },
  methods: {
    // check if  login
    onCheckloginRole() {
      // var temp = localStorage.getItem("auth");
      // if (temp == undefined || temp != "b60afdc1f3657130c165d32743603a59") {
      //   this.$router.push("/login");
      // }
      var temp = localStorage.getItem("auth");
      this.axios
        .post(this.$urlGlobal + "adminCheck", {
          auth: temp,
        })
        .then((res) => {
          if (res.data.code == -1) {
            this.$router.push("/login");
            localStorage.removeItem("auth");
            window.location.reload();
          }
        });
    },

    // fetch categories
    onFetchProductCategoriesData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchCategories", {})
        .then((res) => {
          this.tableDataList = res.data.data;
          this.fullscreenLoading = false;
        });
    },
    onCateChange() {
      this.form.belongSubCategoriesId = "";
      this.onFetchProductSubCategoriesData();
    },
    // fetch sub categories
    onFetchProductSubCategoriesData() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminFetchSubCategoriesById", {
          belongCategoriesId: this.currentData.id,
        })
        .then((res) => {
          console.log(res.data);
          this.subCategoriesList = res.data.data;
          this.fullscreenLoading = false;
        });
    },

    // add new cate operation
    onDialogBoolAddNewOpen() {
      this.boolAddNew = true;
      this.form.type = "大项";
    },
    onDialogBoolAddNewClose() {
      this.boolAddNew = false;
      // also close edit because they use same form
      this.boolEdit = false;
      this.form = {
        belongCategoriesId: "",
        name: "",
        type: "",
        displayArea: "",
        imgUrl: "",
      };
    },

    //  image operation
    onImgRemove(file, fileList) {
      this.form.imgUrl = "";
    },
    onImgUpload(file) {
      this.form.imgUrl = file.data;
    },

    // categories add confirm
    onAddNewConfirm() {
      // 通用检查
      if (
        this.form.type == "" ||
        this.form.name == "" ||
        this.form.imgUrl == ""
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }

      var displayArea = "";
      if (this.form.displayArea == "主页") {
        displayArea = "主页";
      }

      this.fullscreenLoading = true;
      this.boolAddNew = false;

      this.axios
        .post(this.$urlGlobal + "adminAddNewCategories", {
          name: this.form.name,
          imgUrl: this.form.imgUrl,
          displayArea: displayArea,
        })
        .then((res) => {
          // console.log(res.data.data);
          if (res.data.code == 1) {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchProductCategoriesData();
          this.fullscreenLoading = false;
        });
    },

    // edit categories operation
    onDialogBoolEditOpen() {
      this.boolAddNew = true;
      this.boolEdit = true;
      this.form = {
        belongCategoriesId: "",
        name: this.currentData.name,
        type: "大项",
        displayArea: this.currentData.displayArea,
        imgUrl: this.currentData.imgUrl,
      };
    },
    onEditConfirm() {
      if (
        this.form.type == "" ||
        this.form.name == "" ||
        this.form.imgUrl == ""
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }

      var displayArea = "";
      if (this.form.displayArea == "主页") {
        displayArea = "主页";
      }

      this.fullscreenLoading = true;
      this.boolAddNew = false;

      this.axios
        .post(this.$urlGlobal + "adminEditCategories", {
          id: this.currentData.id,
          name: this.form.name,
          imgUrl: this.form.imgUrl,
          displayArea: displayArea,
        })
        .then((res) => {
          // console.log(res.data.data);
          if (res.data.code == 1) {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewClose();
          this.onFetchProductCategoriesData();
          this.fullscreenLoading = false;
        });
    },

    // delete  operation
    onDialogBoolDeleteOpen() {
      this.boolDelete = true;
    },
    onDialogBoolDeleteClose() {
      this.boolDelete = false;
    },
    onDeleteConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminDeleteCategories", {
          id: this.currentData.id,
        })
        .then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.onDialogBoolDeleteClose();
          this.onFetchProductCategoriesData();
          this.fullscreenLoading = false;
        });
    },

    // open sub categories
    onDialogBoolSubOpen() {
      this.boolSubCate = true;
      this.form.belongCategoriesId = this.currentData.id;
      this.onFetchProductSubCategoriesData();
    },

    // add new  sub cate operation
    onDialogBoolAddNewSubOpen() {
      this.boolAddNewSub = true;
      this.form.type = "小项";
    },
    onDialogBoolAddNewSubClose() {
      this.boolAddNewSub = false;
      // also close edit because they use same form
      this.boolEditSub = false;
      this.form = {
        belongCategoriesId: this.currentData.id,
        name: "",
        type: "",
        displayArea: "",
        imgUrl: "",
      };
    },

    // edit sub cate open
    onDialogBoolEditSubOpen() {
      this.boolAddNewSub = true;
      this.boolEditSub = true;
      this.form = {
        belongCategoriesId: this.currentData.id,
        name: this.currentSubData.name,
        type: "小项",
        displayArea: "",
        imgUrl: this.currentSubData.imgUrl,
      };
    },

    // add new sub confirm
    onAddNewSubConfirm() {
      if (
        this.form.type == "" ||
        this.form.name == "" ||
        this.form.imgUrl == "" ||
        this.form.belongCategoriesId == ""
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }
      this.boolAddNewSub = false;

      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminAddNewSubCategories", {
          name: this.form.name,
          imgUrl: this.form.imgUrl,
          belongCategoriesId: this.form.belongCategoriesId,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewSubClose();
          this.onFetchProductSubCategoriesData();
        });
    },

    // edit sub confirm
    onEditSubConfirm() {
      if (
        this.form.type == "" ||
        this.form.name == "" ||
        this.form.imgUrl == "" ||
        this.form.belongCategoriesId == ""
      ) {
        this.$message({
          message: "尚有未填信息",
          type: "warning",
        });
        return;
      }

      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminEditSubCategories", {
          id: this.currentSubData.id,
          name: this.form.name,
          imgUrl: this.form.imgUrl,
          belongCategoriesId: this.form.belongCategoriesId,
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == 1) {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          } else {
            this.$message({
              message: "操作成功",
              type: "success",
            });
          }
          this.onDialogBoolAddNewSubClose();
          this.onFetchProductSubCategoriesData();
        });
    },

    onDialogWithSubData(scope, e) {
      this.currentSubData = scope.row;
      switch (e) {
        case "edit":
          this.onDialogBoolEditSubOpen();
          break;
        case "delete":
          this.onDialogBoolDeleteSubOpen();
          break;
      }
    },

    // delete sub
    onDialogBoolDeleteSubOpen() {
      this.boolDeleteSub = true;
    },
    onDialogBoolDeleteSubClose() {
      this.boolDeleteSub = false;
    },
    onDeleteSubConfirm() {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminDeleteSubCategories", {
          id: this.currentSubData.id,
        })
        .then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.onDialogBoolDeleteSubClose();
          this.onFetchProductSubCategoriesData();
          this.fullscreenLoading = false;
        });
    },

    // order
    onDialogBoolOrderOpen(e) {
      this.fullscreenLoading = true;
      this.axios
        .post(this.$urlGlobal + "adminMoveCategories", {
          id: this.currentData.id,
          orderType: e,
        })
        .then((res) => {
          this.onFetchProductCategoriesData();
          this.fullscreenLoading = false;
        });
    },

    // table operation
    onDialogWithData(scope, e) {
      this.currentData = scope.row;
      switch (e) {
        case "subCate":
          this.onDialogBoolSubOpen();
          break;
        case "up":
          this.onDialogBoolOrderOpen("up");
          break;
        case "down":
          this.onDialogBoolOrderOpen("down");
          break;
        case "edit":
          this.onDialogBoolEditOpen();
          break;
        case "delete":
          this.onDialogBoolDeleteOpen();
          break;
      }
    },

    onGoTo(e) {
      this.boolSubCate = false;
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

